export default "__VITE_PUBLIC_ASSET__82523d9d__"